__turbopack_context__.v({
  "className": "inter_b2cac8b1-module__YDIO3G__className",
  "variable": "inter_b2cac8b1-module__YDIO3G__variable",
});
